import React from 'react';
import BaseSection from './_shared/BaseSection';
import BenefitsCards from '../cards/BenefitsCards';

const BenefitsSection = ({ id }, ref) => {
    return (
        <BaseSection
            id={id}
            name="Benefits"
            // introduction="FanCollex® can be used for different areas such as fan engagement, merchandise, corporate, hospitality and even sponsoring."
            introduction="FanCollex® can be used in different areas such as, fan engagement, merchandise, corporate, hospitality and even sponsorships."
            iSize="section-text-default"
            iColor="mylads-text-gradient"
            ref={ref}
        >
            <BenefitsCards />
        </BaseSection>
    );
};

export default React.forwardRef(BenefitsSection);
